<template>
  <span>
    <router-link
      class="add-spacing"
      :to="{
        name: 'Stat Insp Items Filter',
        query: {
          typeId: this.typeId,
          statusId: this.statusId,
          contractorRegionId: this.contractorRegionId
        }
      }"
      >{{ this.statInspItemStatus(this.statusId).name
      }}<strong>({{ value }})</strong></router-link
    >&nbsp;&nbsp;
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "chart-link",
  props: {
    typeId: {
      type: Number,
      default: () => 0
    },
    contractorRegionId: {
      type: String,
      default: () => "0"
    },
    statusId: {
      type: Number,
      default: () => 0
    },
    value: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    ...mapGetters({
      statInspItemStatus: "stat-insp/statInspItemStatus"
    })
  }
};
</script>

<style>
.add-spacing {
  padding-left: 0.25em;
}
</style>
